import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  init: () => {
    const overviewMediaItems = document.querySelectorAll("[data-overview-media-item]");

    overviewMediaItems.forEach((item) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 120%",
          end: window.innerWidth < 768 ? "bottom 65%" : "bottom 95%",
          pin: false,
          scrub: true,
        },
      });

      tl.fromTo(item, {
        scale: 0.4,
        clipPath: window.innerWidth < 768 ?  "inset(50% round 10px)" : "inset(50% round 20px)",
        transformOrigin: "bottom center",
        ease: "none"
      }, {
        scale: 1,
        clipPath: window.innerWidth < 768 ? "inset(0% round 10px)" : "inset(0% round 20px)",
        ease: "power3.inOut",
      })

    });
  },
}
